/* MGH 07/10/2026: flores por zona (zona = seccoes brancas seguidas): cantos de cima e de baixo e, em zonas altas,
   grupos de flores nas laterais intercalados (sempre inteiros, sem esmaecer). Os dados do desenho estao aqui dentro (sem pedidos extra).
   As flores entram 2px por baixo das barras azuis para nao aparecer linha clara nas transicoes.
   Telemovel (menos de 600px): so os 4 cantos, mais pequenos, sem grupos laterais.
   Recalcula quando o conteudo muda de altura. Para desligar: apagar a linha render 'mgh-fundo' em snippets/meta-tags.liquid. */
(function () {
  var W = 640, H = 520, EXT = 2;
  var DEFS = `<defs><path id='b1' d='M0,180 C80,170 170,120 290,18 L294,22 C180,132 90,188 2,198 Z M105,152 C112,120 118,90 138,58 L143,61 C126,92 122,122 118,148 Z M185,102 C215,104 240,112 268,128 L266,133 C238,119 214,112 186,112 Z M55,172 C52,150 46,130 34,110 L39,107 C52,128 60,150 64,170 Z'/><path id='b2' d='M300,180 C220,170 130,120 10,18 L6,22 C120,132 210,188 298,198 Z M195,152 C188,120 182,90 162,58 L157,61 C174,92 178,122 182,148 Z M115,102 C85,104 60,112 32,128 L34,133 C62,119 86,112 114,112 Z M245,172 C248,150 254,130 266,110 L261,107 C248,128 240,150 236,170 Z'/><path id='f' d='M50,50 C35,38 29,17 43,3 L50,10 L57,3 C71,17 65,38 50,50 Z M50,50 C57,32 75,20 93,29 L88,38 L97,42 C88,60 66,61 50,50 Z M50,50 C69,51 86,64 83,84 L74,82 L72,92 C52,89 45,69 50,50 Z M50,50 C55,69 48,89 28,92 L26,82 L17,84 C14,64 31,51 50,50 Z M50,50 C34,61 12,60 3,42 L12,38 L7,29 C25,20 43,32 50,50 Z'/></defs>`;
  /* peca: [xml, esquerda, direita, topo, fundo] na grelha 1920x760 do desenho original */
  var DESIGN = {
    left: [
      [`<use href='#b1' transform='translate(46.8 190.6) rotate(104.1) translate(-185.5 -123.7) scale(1.2367 1.2370)' fill='#c9a394'/>`, -114, 190, -19, 388],
      [`<use href='#f' transform='translate(25 35) rotate(10) translate(-135 -135) scale(2.7000 2.7000)' fill='#f2a9b5'/>`, -120, 172, -112, 169],
      [`<use href='#f' transform='translate(185 -15) rotate(40) translate(-75 -75) scale(1.5000 1.5000)' fill='#d3e8f4'/>`, 90, 284, -114, 79],
      [`<use href='#f' transform='translate(5 215) rotate(-25) translate(-75 -75) scale(1.5000 1.5000)' fill='#f9d5d8'/>`, -89, 96, 121, 302],
      [`<use href='#f' transform='translate(95 350) rotate(15) translate(-45 -45) scale(0.9000 0.9000)' fill='#cfe5f2'/>`, 44, 147, 298, 397]
    ],
    right: [
      [`<use href='#b2' transform='translate(1878.2 198.3) rotate(-105.9) translate(-190.8 -127.2) scale(1.2720 1.2720)' fill='#c9a394'/>`, 1726, 2048, -19, 403],
      [`<use href='#f' transform='translate(1905 25) rotate(35) translate(-115 -115) scale(2.3000 2.3000)' fill='#d3e8f4'/>`, 1761, 2056, -126, 166],
      [`<use href='#f' transform='translate(1932 200) rotate(-5) translate(-70 -70) scale(1.4000 1.4000)' fill='#f2a9b5'/>`, 1861, 2003, 129, 264],
      [`<use href='#f' transform='translate(1765 -20) rotate(20) translate(-55 -55) scale(1.1000 1.1000)' fill='#f9d5d8'/>`, 1701, 1831, -86, 41]
    ],
    /* grupos laterais (ramo a sair do bordo + 5 flores, todas inteiras dentro da caixa) */
    mid: {
      left: [
        [`<use href='#b1' transform='translate(30 200) rotate(100) translate(-150 -100) scale(1)' fill='#c9a394'/>`, -100, 146, 30, 359],
        [`<use href='#f' transform='translate(20 100) rotate(10) translate(-75 -75) scale(1.5)' fill='#f2a9b5'/>`, -73, 113, 7, 193],
        [`<use href='#f' transform='translate(110 205) rotate(-20) translate(-55 -55) scale(1.1)' fill='#f9d5d8'/>`, 42, 178, 137, 273],
        [`<use href='#f' transform='translate(30 315) rotate(30) translate(-65 -65) scale(1.3)' fill='#d3e8f4'/>`, -51, 111, 234, 396],
        [`<use href='#f' transform='translate(125 385) rotate(0) translate(-35 -35) scale(0.7)' fill='#f2a9b5'/>`, 77, 163, 342, 428],
        [`<use href='#f' transform='translate(128 118) rotate(15) translate(-27.5 -27.5) scale(0.55)' fill='#cfe5f2'/>`, 94, 162, 84, 152]
      ],
      right: [
        [`<use href='#b2' transform='translate(1890 200) rotate(-100) translate(-150 -100) scale(1)' fill='#c9a394'/>`, 1774, 2020, 30, 359],
        [`<use href='#f' transform='translate(1900 100) rotate(-10) translate(-75 -75) scale(1.5)' fill='#f2a9b5'/>`, 1807, 1993, 7, 193],
        [`<use href='#f' transform='translate(1810 205) rotate(20) translate(-55 -55) scale(1.1)' fill='#f9d5d8'/>`, 1742, 1878, 137, 273],
        [`<use href='#f' transform='translate(1890 315) rotate(-30) translate(-65 -65) scale(1.3)' fill='#d3e8f4'/>`, 1809, 1971, 234, 396],
        [`<use href='#f' transform='translate(1795 385) rotate(0) translate(-35 -35) scale(0.7)' fill='#f2a9b5'/>`, 1757, 1843, 342, 428],
        [`<use href='#f' transform='translate(1792 118) rotate(-15) translate(-27.5 -27.5) scale(0.55)' fill='#cfe5f2'/>`, 1758, 1826, 84, 152]
      ]
    }
  };
  var timer = null, last = '', first = true;

  function opaca(el) {
    var c = getComputedStyle(el).backgroundColor;
    return c !== 'rgba(0, 0, 0, 0)' && c !== 'transparent';
  }

  function limpar(M) {
    Array.prototype.slice.call(M.children).forEach(function (e) { if (e.classList.contains('mgh-fl')) e.remove(); });
  }

  function construir() {
    var t0 = performance.now();
    var M = document.getElementById('MainContent');
    if (!M) return;
    var CW = document.documentElement.clientWidth;
    var mob = CW < 600;
    var kids = Array.prototype.filter.call(M.children, function (e) { return !e.classList.contains('mgh-fl'); });

    kids.forEach(function (k) {
      if (!k.offsetHeight) return;
      var g = k.querySelector('.gradient');
      if (g && g.offsetWidth >= CW - 2 && getComputedStyle(g).backgroundColor === 'rgb(255, 255, 255)') g.classList.add('mgh-fundo-transp');
    });

    var cls = kids.map(function (k) {
      if (!k.offsetHeight) return 'z';
      var g = k.querySelector('.gradient');
      if (!g) return opaca(k) ? 'c' : 'w';
      if (g.classList.contains('mgh-fundo-transp')) return 'w';
      return g.offsetWidth >= CW - 2 && opaca(g) ? 'c' : 'w';
    });

    var zonas = [], cur = null;
    kids.forEach(function (k, i) {
      if (cls[i] === 'w') {
        if (!cur) cur = { a: k, b: k };
        cur.b = k;
      } else if (cls[i] === 'c' && cur) {
        zonas.push(cur);
        cur = null;
      }
    });
    if (cur) zonas.push(cur);

    var mr = M.getBoundingClientRect();
    var oX = mr.left + window.pageXOffset, oY = mr.top + window.pageYOffset;
    zonas.forEach(function (z) {
      z.t = z.a.getBoundingClientRect().top - mr.top;
      z.u = z.b.getBoundingClientRect().bottom - mr.top;
    });

    var sig = CW + '|' + Math.round(mr.height) + '|' + zonas.map(function (z) { return Math.round(z.t) + ':' + Math.round(z.u); }).join(',');
    if (sig === last && M.querySelector(':scope > .mgh-fl')) return;
    last = sig;

    /* Caixas das flores: 4 cantos por zona + (so no computador) grupos laterais intercalados nas zonas altas */
    var boxes = [];
    zonas.forEach(function (z) {
      var top = z.t, bottom = z.u, Hz = bottom - top;
      var sc = Math.min(0.8, Hz * 1.3 / 1040, CW * (mob ? 0.34 : 0.30) / W);
      var w = Math.round(W * sc), h = Math.round(H * sc);
      var topY = Math.floor(top) - (top > 1 ? EXT : 0);
      var botY = Math.ceil(bottom) + (bottom < mr.height - 1 ? EXT : 0);
      ['top', 'bot'].forEach(function (pos) {
        ['left', 'right'].forEach(function (side) {
          boxes.push({
            design: pos === 'top' ? side : (side === 'left' ? 'right' : 'left'),
            fx: pos === 'bot', fy: pos === 'bot', mid: false, sc: sc, w: w, h: h,
            dx: side === 'left' ? 0 : CW - w, dy: pos === 'top' ? topY : botY - h
          });
        });
      });
      if (mob) return;
      var ms = sc * 0.7, mw = Math.round(W * ms), mh = Math.round(H * ms), step = mh * 1.9, k = 0;
      for (var c = top + h + step / 2; c + mh / 2 <= bottom - h; c += step, k++) {
        var side = k % 2 ? 'right' : 'left';
        boxes.push({
          design: side, fx: false, fy: Math.floor(k / 2) % 2 === 1, mid: true, sc: ms, w: mw, h: mh,
          dx: side === 'left' ? 0 : CW - mw, dy: Math.round(c - mh / 2)
        });
      }
    });

    /* Texto solto (fora de cartoes opacos) que fica dentro de alguma caixa: as flores nao podem ficar atras dele */
    var rects = [];
    var wk = document.createTreeWalker(M, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = wk.nextNode())) {
      if (!n.nodeValue.trim()) continue;
      var rg = document.createRange();
      rg.selectNodeContents(n);
      var qs = rg.getClientRects(), keep = [];
      for (var qi = 0; qi < qs.length; qi++) {
        var q = qs[qi];
        if (q.width <= 1) continue;
        var r = [q.left + window.pageXOffset, q.top + window.pageYOffset, q.right + window.pageXOffset, q.bottom + window.pageYOffset];
        if (boxes.some(function (b) { return r[0] < oX + b.dx + b.w && r[2] > oX + b.dx && r[1] < oY + b.dy + b.h && r[3] > oY + b.dy; })) keep.push(r);
      }
      if (!keep.length) continue;
      var el = n.parentElement;
      if (!el || el.closest('script,style,noscript,svg')) continue;
      var a = el, op = false;
      while (a && a !== M) {
        if (opaca(a)) { op = true; break; }
        a = a.parentElement;
      }
      if (op) continue;
      rects = rects.concat(keep);
    }

    var frag = document.createDocumentFragment();
    boxes.forEach(function (b) {
      var x0 = b.design === 'left' ? 0 : 1920 - W;
      var lista = b.mid ? DESIGN.mid[b.design] : DESIGN[b.design];
      var ok = lista.filter(function (i) {
        var u1 = (i[1] - x0) * b.sc, u2 = (i[2] - x0) * b.sc, v1 = i[3] * b.sc, v2 = i[4] * b.sc, t;
        if (b.fx) { t = u1; u1 = b.w - u2; u2 = b.w - t; }
        if (b.fy) { t = v1; v1 = b.h - v2; v2 = b.h - t; }
        var bx = [oX + b.dx + u1 - 6, oY + b.dy + v1 - 6, oX + b.dx + u2 + 6, oY + b.dy + v2 + 6];
        return !rects.some(function (r) { return r[0] < bx[2] && r[2] > bx[0] && r[1] < bx[3] && r[3] > bx[1]; });
      });
      var s = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='" + x0 + ' 0 ' + W + ' ' + H + "'>" + DEFS + ok.map(function (i) { return i[0]; }).join('') + '</svg>';
      var e = document.createElement('div');
      e.className = 'mgh-fl';
      e.setAttribute('aria-hidden', 'true');
      e.style.cssText = 'width:' + b.w + 'px;height:' + b.h + 'px;' + (b.dx ? 'right' : 'left') + ':0;top:' + b.dy + 'px;background-image:url(' + "'data:image/svg+xml;utf8," + encodeURIComponent(s).replace(/'/g, '%27') + "')" + ';transform:' + (b.fx || b.fy ? 'scale(' + (b.fx ? -1 : 1) + ',' + (b.fy ? -1 : 1) + ')' : 'none');
      frag.appendChild(e);
    });

    limpar(M);
    M.appendChild(frag);
    if (first) {
      first = false;
      M.classList.add('mgh-fl-first');
      setTimeout(function () { M.classList.remove('mgh-fl-first'); }, 900);
    }
    window.mghFundoMs = Math.round(performance.now() - t0);
  }

  function correr() {
    try { construir(); } catch (err) { /* o fundo e so decoracao: nunca pode estragar a pagina */ }
  }

  function agendar() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; correr(); }, 120);
  }

  function iniciar() {
    document.documentElement.classList.add('mgh-fundo-on');
    correr();
    window.addEventListener('load', agendar);
    window.addEventListener('resize', agendar);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { agendar(); });
    var M = document.getElementById('MainContent');
    if (M && window.ResizeObserver) new ResizeObserver(agendar).observe(M);
    document.addEventListener('shopify:section:load', agendar);
    document.addEventListener('shopify:section:unload', agendar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
